jQuery(function ($) {
  "use strict";

  const backLine = document.querySelector(".back-line");

  document
    .querySelectorAll(".c-post__link-list a[data-part]")
    .forEach((link) => {
      const target = document.querySelector(`.body-part.${link.dataset.part}`);
      if (!target) return;

      link.addEventListener("mouseenter", () => {
        target.classList.add("is-active");
        // backボタンのときは縦線も表示
        if (link.dataset.part === "back" && backLine) {
          backLine.style.opacity = "1";
        }
      });
      link.addEventListener("mouseleave", () => {
        target.classList.remove("is-active");
        if (link.dataset.part === "back" && backLine) {
          backLine.style.opacity = "0";
        }
      });
    });

  // SVG直接ホバー
  const backPart = document.querySelector(".body-part.back");
  if (backPart && backLine) {
    backPart.addEventListener(
      "mouseenter",
      () => (backLine.style.opacity = "1"),
    );
    backPart.addEventListener(
      "mouseleave",
      () => (backLine.style.opacity = "0"),
    );
  }
});
